// src/components/TeachingPlanCard/JourneyDownloadCard.js
import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";

import AiBorderWrapper from "../AIBorderWrapper";
import DownloadJourneyButton from "../DownloadJourneyButton";

import { LLM_DISCLAIMER_TEXT } from "../../config/t4rConfig";

/**
 * JourneyDownloadCard
 *
 * - Outer AiBorderWrapper: static AI gradient (no shimmer) around the card.
 * - Inner AiBorderWrapper: shimmering border only around the Download button.
 */
export default function JourneyDownloadCard({
  finalMd,
  journeySummary,
  disabled,
  onDownload,
}) {
  return (
    <AiBorderWrapper aiActive animated={false} sx={{ mt: 3 }}>
      <Paper
        variant="outlined"
        sx={{
          p: 2.5,
          borderRadius: 2,
          bgcolor: "background.paper",
        }}
      >
        {/* Short intro text */}
        <Typography variant="body2" color="text.primary" paragraph>
          When you download the journey, you receive an <em>HTML document</em>{" "}
          that can be opened directly in <strong>Microsoft Word</strong>. The
          first section contains the session-by-session teaching table. If you
          scroll down, you will find the <em>session context and logs</em> that
          document how this plan was assembled in Steps 1–6.
        </Typography>

        {/* AI disclaimer */}
        <Box
          sx={{
            mt: 1,
            mb: 2,
            p: 1.5,
            borderRadius: 2,
            bgcolor: "rgba(0, 0, 0, 0.03)",
            borderLeft: "4px solid",
            borderColor: "grey.600",
            display: "flex",
            alignItems: "flex-start",
            gap: 1.25,
          }}
        >
          <VerifiedUserOutlinedIcon
            sx={{
              fontSize: 22,
              color: "grey.700",
              mt: 0.2,
              flexShrink: 0,
            }}
          />
          <Typography variant="body2" color="text.secondary">
            {LLM_DISCLAIMER_TEXT} Treat the downloaded document as a draft
            and adapt it to your teaching context.
          </Typography>
        </Box>

        {/* Download button — right aligned, shimmer on border only */}
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <AiBorderWrapper
            aiActive
            animated
            sx={{
              p: "2px",
              borderRadius: 9999,
              display: "inline-flex",
            }}
          >
            <DownloadJourneyButton
              finalMd={finalMd}
              journeySummary={journeySummary}
              disabled={disabled}
              onDownload={onDownload}
            />
          </AiBorderWrapper>
        </Box>
      </Paper>
    </AiBorderWrapper>
  );
}
